<div class="container-fluid py-3">
    <ng-container>
        <div class="card mb-3">
            <div class="card-header">
                <h1>Solicitud de Depósitos</h1>
                <small>
                    Consulte y registre los traslados de caja hacia banco
                </small>
            </div>
            <div class="card-body">
                <div class="row align-items-end">
                    <div class="col-md-5 mb-3 mb-md-0">

                        <label>
                            Bodega
                            <span class="text-danger">
                                *
                            </span>
                        </label>

                        <select
                            class="form-control"
                            [(ngModel)]="selectedWarehouseId"
                        >

                            <option
                                [ngValue]="null"
                            >
                                Seleccione una bodega
                            </option>

                            <option
                                *ngFor="let warehouse of warehouses"
                                [ngValue]="warehouse.id"
                            >
                                {{ warehouse.name }}
                            </option>

                        </select>

                    </div>

                    <div class="col-md-4 mb-3 mb-md-0">

                        <label>
                            Fecha
                        </label>

                        <input
                            type="date"
                            class="form-control"
                            [(ngModel)]="selectedDate"
                        >

                    </div>

                    <div class="col-md-3">

                        <button
                            type="button"
                            class="btn btn-primary btn-block"
                            [disabled]="loading"
                            (click)="loadDeposits()"
                        >

                            <ng-container
                                *ngIf="!loading"
                            >
                                <i class="fa fa-search mr-2"></i>
                                Buscar
                            </ng-container>

                            <ng-container
                                *ngIf="loading"
                            >
                                <span
                                    class="spinner-border spinner-border-sm mr-2"
                                ></span>

                                Buscando...
                            </ng-container>

                        </button>

                    </div>

                </div>

            </div>

        </div>

        <div
            *ngIf="loading"
            class="text-center py-5"
        >

            <div
                class="spinner-border text-primary"
            ></div>

            <div class="mt-2 text-muted">
                Cargando depósitos...
            </div>

        </div>

        <div
            *ngIf="!loading && deposits.length === 0"
            class="card"
        >

            <div class="card-body text-center py-5">

                <i
                    class="fa fa-inbox text-muted mb-3"
                    style="font-size: 45px;"
                ></i>

                <div class="text-muted">
                    No hay depósitos para esta fecha
                </div>

            </div>

        </div>

        <div
            *ngIf="!loading && deposits.length > 0"
        >

            <div
                class="card mb-2"
                *ngFor="
                    let deposit of deposits;
                    trackBy: trackByDeposit
                "
                [class.border-secondary]="isCashDeposit(deposit)"
                [class.cursor-pointer]="!isCashDeposit(deposit)"
                (click)="
                    !isCashDeposit(deposit)
                        ? openDepositForm(deposit)
                        : null
                "
            >

                <div class="card-body">

                    <div
                        class="d-flex align-items-center"
                    >

                        <div
                            class="mr-3 text-center"
                            style="width: 45px;"
                        >

                            <i
                                *ngIf="isCashDeposit(deposit)"
                                class="fa fa-money text-secondary"
                                style="font-size: 30px;"
                            ></i>

                            <i
                                *ngIf="!isCashDeposit(deposit)"
                                class="fa fa-university text-primary"
                                style="font-size: 30px;"
                            ></i>

                        </div>

                        <div class="flex-grow-1">

                            <div
                                class="font-weight-bold"
                                [class.text-secondary]="isCashDeposit(deposit)"
                            >
                                {{ getDepositTitle(deposit) }}
                            </div>

                            <div
                                class="font-weight-bold text-success mt-1"
                            >
                                Q.
                                {{
                                    deposit.amount
                                    | number:'1.2-2'
                                }}
                            </div>

                        </div>

                        <div
                            *ngIf="!isCashDeposit(deposit)"
                        >
                            <i
                                class="fa fa-chevron-right text-muted"
                            ></i>
                        </div>

                        <div
                            *ngIf="isCashDeposit(deposit)"
                        >
                            <small class="text-muted">
                                No disponible
                            </small>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </ng-container>

</div>



<div
    *ngIf="showDepositModal"
    class="modal fade show d-block"
    tabindex="-1"
    style="background-color: rgba(0, 0, 0, 0.5);"
>

    <div
        class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
        role="document"
    >

        <div class="modal-content">

            <div class="modal-header">

                <div>

                    <h5 class="modal-title">
                        Traslado desde Caja hacia Banco
                    </h5>

                    <small
                        class="text-muted"
                        *ngIf="selectedDeposit"
                    >
                        {{ getDepositTitle(selectedDeposit) }}
                    </small>

                </div>
            </div>

            <div class="modal-body">
                <div class="row">
                    <div class="col-md-6 mb-3">

                        <label>
                            Caja
                            <span class="text-danger">
                                *
                            </span>
                        </label>

                        <select
                            class="form-control"
                            [(ngModel)]="selectedCashId"
                            [disabled]="saving"
                        >

                            <option
                                [ngValue]="null"
                            >
                                Seleccione una caja
                            </option>

                            <option
                                *ngFor="let cash of cashiers"
                                [ngValue]="cash.id"
                            >
                                {{ getCashName(cash) }}
                            </option>

                        </select>

                    </div>

                    <div class="col-md-6 mb-3">

                        <label>
                            Banco
                            <span class="text-danger">
                                *
                            </span>
                        </label>

                        <select
                            class="form-control"
                            [(ngModel)]="selectedBankAccountId"
                            [disabled]="saving"
                        >

                            <option
                                [ngValue]="null"
                            >
                                Seleccione una cuenta
                            </option>

                            <option
                                *ngFor="let account of bankAccounts"
                                [ngValue]="account.id"
                            >
                                {{ getBankName(account) }}
                            </option>

                        </select>

                    </div>

                    <div class="col-md-6 mb-3">

                        <label>
                            Referencia
                        </label>

                        <input
                            type="text"
                            class="form-control"
                            placeholder="Ingresa la referencia"
                            [(ngModel)]="reference"
                            [disabled]="saving"
                        >

                    </div>

                    <div class="col-md-6 mb-3">

                        <label>
                            Monto (Q)
                        </label>

                        <div class="input-group">

                            <div class="input-group-prepend">

                                <span class="input-group-text">
                                    Q
                                </span>

                            </div>

                            <input
                                type="number"
                                class="form-control"
                                [(ngModel)]="amountQ"
                                min="0"
                                step="0.01"
                                [disabled]="saving"
                            >

                        </div>

                    </div>

                    <div class="col-md-12 mb-3">

                        <label>
                            Descripción
                        </label>

                        <textarea
                            class="form-control"
                            rows="3"
                            placeholder="Ingresa una descripción"
                            [(ngModel)]="description"
                            [disabled]="saving"
                        ></textarea>

                    </div>

                    <div class="col-md-6 mb-3">

                        <label>
                            Fecha
                        </label>

                        <input
                            type="date"
                            class="form-control"
                            [(ngModel)]="formDate"
                            [disabled]="saving"
                        >

                    </div>


                    <div class="col-md-12">

                        <label>
                            Imagen
                        </label>

                        <div
                            class="border rounded p-3 text-center"
                        >

                            <ng-container
                                *ngIf="!imagePreview"
                            >

                                <label
                                    class="mb-0 w-100"
                                    style="cursor: pointer;"
                                >

                                    <div class="py-4">

                                        <i
                                            class="fa fa-camera text-muted mb-2"
                                            style="font-size: 40px;"
                                        ></i>

                                        <div class="text-muted">
                                            Presione para seleccionar una imagen
                                        </div>

                                    </div>

                                    <input
                                        type="file"
                                        accept="image/*"
                                        class="d-none"
                                        [disabled]="saving"
                                        (change)="onImageSelected($event)"
                                    >

                                </label>

                            </ng-container>


                            <ng-container
                                *ngIf="imagePreview"
                            >

                                <img
                                    [src]="imagePreview"
                                    alt="Imagen seleccionada"
                                    class="img-fluid rounded mb-3"
                                    style="
                                        max-height: 300px;
                                        object-fit: contain;
                                    "
                                >

                                <div>

                                    <button
                                        type="button"
                                        class="btn btn-outline-danger btn-sm"
                                        [disabled]="saving"
                                        (click)="removeImage()"
                                    >
                                        <i class="fa fa-trash mr-1"></i>
                                        Quitar imagen
                                    </button>

                                </div>

                            </ng-container>

                        </div>

                    </div>

                </div>

            </div>

            <div class="modal-footer">

                <button
                    type="button"
                    class="btn btn-secondary"
                    [disabled]="saving"
                    (click)="closeDepositModal()"
                >
                    Cancelar
                </button>

                <button
                    type="button"
                    class="btn btn-primary"
                    [disabled]="saving"
                    (click)="saveFormData()"
                >

                    <ng-container
                        *ngIf="!saving"
                    >
                        <i class="fa fa-save mr-2"></i>
                        Guardar traslado
                    </ng-container>

                    <ng-container
                        *ngIf="saving"
                    >

                        <span
                            class="spinner-border spinner-border-sm mr-2"
                        ></span>

                        Guardando...

                    </ng-container>

                </button>

            </div>

        </div>

    </div>

</div>